module.exports = __webpack_public_path__ + "static/media/08.34864637.mp3";